import request from '@/utils/request'

export function getPlc(pageNum) {
    return request({
        url: '/PLC/login',
        method: 'get',
        params: { pageNum }
    })
}

export function gets7200smart(pageNum) {
    return request({
        url: '/PLC/s7200smart',
        method: 'get',
        params: { pageNum }
    })
}

export function gets71200(pageNum) {
    return request({
        url: '/PLC/s71200',
        method: 'get',
        params: { pageNum }
    })
}